import React from 'react';
import Footer from '../components/Footer';

// Honeymoon Fund — the card renders only once stripeUrl is set.
// stripeUrl: a Stripe Payment Link (Dashboard → Payment links), which hosts the
// card / Apple Pay checkout and deposits to the linked bank account.
// venmoHandle: Venmo username without the @, shown as the no-fee alternative.
const HONEYMOON_FUND = {
  stripeUrl: 'https://buy.stripe.com/9B67sN8M0bNI9T74big7e00',
  venmoHandle: 'michaelgeorge1',
};

export default function Registry() {
  return (
    <div className="site-wrapper">
      {/* Full-page photo + cream veil — same pattern as other pages */}
      <div className="rsvp-bg-photo" style={{ backgroundImage: "url('/Four Seasons Naples-FSNaples-092025-JoeThomas-v2-3_1.png')" }} />
      <div className="rsvp-bg-overlay" />

      <div className="page-content" style={{ position: 'relative', zIndex: 2 }}>
        <div className="registry-content" style={{ maxWidth: '860px', margin: '0 auto', padding: '40px 40px 80px' }}>
          <h2 style={{
            fontFamily: 'var(--font-script)',
            fontSize: '60px',
            fontWeight: 400,
            color: 'var(--green-dark)',
            textAlign: 'center',
            marginBottom: '8px',
            lineHeight: 1.2,
          }}>Registry</h2>

          <p className="registry-intro">
            Your presence is the greatest gift. For those who have asked,
            we've set up a honeymoon fund.
          </p>

          {HONEYMOON_FUND.stripeUrl && (
            <div className="registry-card" style={{ maxWidth: '560px', margin: '0 auto' }}>
              <h3 style={{ marginBottom: '24px' }}>Honeymoon Fund</h3>
              <a
                href={HONEYMOON_FUND.stripeUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-primary"
              >
                Contribute
              </a>
              {HONEYMOON_FUND.venmoHandle && (
                <p style={{ marginTop: '16px', fontSize: '0.85rem', color: 'var(--text-medium)' }}>
                  Prefer to skip card fees? Venmo us directly:{' '}
                  <a
                    href={`https://venmo.com/u/${HONEYMOON_FUND.venmoHandle}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ color: 'var(--green-dark)', fontWeight: 600 }}
                  >
                    @{HONEYMOON_FUND.venmoHandle}
                  </a>
                </p>
              )}
            </div>
          )}

          <p style={{
            fontFamily: 'var(--font-serif)',
            fontStyle: 'italic',
            color: 'var(--text-medium)',
            textAlign: 'center',
            marginTop: '40px',
            fontSize: '0.95rem',
          }}>
            Thank you for your love and generosity.
          </p>
        </div>
      </div>
      <Footer />
    </div>
  );
}
